/* eslint-disable */

// Generated from /Users/pyt/Downloads/AudienceLogic.g4 by ANTLR 4.7.1
// jshint ignore: start
import antlr4 from 'antlr4';

import AudienceRule from '../../common/models/audience/AudienceRule';
import rootStore from '../../store/index';
import AudienceGroup from '@/common/models/audience/AudienceGroup';

// This class defines a complete listener for a parse tree produced by AudienceLogicParser.
class AudienceLogicListener extends antlr4.tree.ParseTreeListener {
  constructor(rules, tree) {
    super();
    this.rules = rules;
    this.tree = tree;
    this.currentTreeNode = new AudienceGroup();
    this.lastRule = null;
    this.lastChildNode = null;
    this.operatorStack = [];
  }

  // Enter a parse tree produced by AudienceLogicParser#parse.
  enterParse(ctx) {}

  // Exit a parse tree produced by AudienceLogicParser#parse.
  exitParse(ctx) {
    this.tree.parent = null;
    this.tree.operator = this.currentTreeNode.operator;
    this.tree.addChild(...this.currentTreeNode.nodes);
  }

  // Enter a parse tree produced by AudienceLogicParser#binaryExpression.
  enterBinaryExpression(ctx) {
    this.operatorStack.push(this.currentTreeNode.nodes.length);
  }

  // Exit a parse tree produced by AudienceLogicParser#binaryExpression.
  exitBinaryExpression(ctx) {
    const ix = this.operatorStack.pop();
    const exprNodes = this.currentTreeNode.nodes.splice(ix - 1, 2);

    // Root tree can change to match first operator
    if (!this.currentTreeNode.parent || !this.currentTreeNode.nodes.length) {
      this.currentTreeNode.setOperator(ctx.op.text);
    }

    // Nest on binary exp
    const childTree = new AudienceGroup([], this.currentTreeNode, false, ctx.op.text);
    childTree.isInternal = true;
    childTree.addChild(...exprNodes);
    this.currentTreeNode.insertChild(ix - 1, childTree);
  }

  // Enter a parse tree produced by AudienceLogicParser#parenthesisExpression.
  enterParenthesisExpression(ctx) {
    const childNode = new AudienceGroup(
      [],
      this.currentTreeNode,
      false,
      this.currentTreeNode.operator.value === '&' ? '|' : '&',
    );
    this.currentTreeNode.addChild(childNode);
    this.currentTreeNode = childNode;
  }

  // Exit a parse tree produced by AudienceLogicParser#parenthesisExpression.
  exitParenthesisExpression(ctx) {
    this.lastChildNode = this.currentTreeNode;
    if (this.currentTreeNode.parent !== null) {
      this.currentTreeNode = this.currentTreeNode.parent;
    } else {
      this.currentTreeNode = new AudienceGroup([this.currentTreeNode]);
    }
    this.lastRule = null;
  }

  // Enter a parse tree produced by AudienceLogicParser#notExpression.
  enterNotExpression(ctx) {}

  // Exit a parse tree produced by AudienceLogicParser#notExpression.
  exitNotExpression(ctx) {
    if (this.lastRule !== null) {
      if (this.lastRule.constructor === AudienceRule) {
        rootStore.dispatch('updateAudienceRuleIsNegated', {
          audienceRule: this.lastRule,
          value: !this.lastRule.isNegated,
        });
      } else {
        this.lastRule.isNegated = true;
      }
    } else {
      this.lastChildNode.isNegated = true;
    }
  }

  // Enter a parse tree produced by AudienceLogicParser#literalExpression.
  enterLiteralExpression(ctx) {}

  // Exit a parse tree produced by AudienceLogicParser#literalExpression.
  exitLiteralExpression(ctx) {}

  // Enter a parse tree produced by AudienceLogicParser#binary.
  enterBinary(ctx) {}

  // Exit a parse tree produced by AudienceLogicParser#binary.
  exitBinary(ctx) {}

  // Enter a parse tree produced by AudienceLogicParser#literal.
  enterLiteral(ctx) {
    this.lastRule = this.rules.find((x) => x.key === parseInt(ctx.start.text, 10));
    this.currentTreeNode.addChild(this.lastRule);
  }

  // Exit a parse tree produced by AudienceLogicParser#literal.
  exitLiteral(ctx) {}
}

export { AudienceLogicListener };
